export default {
	"en": {
		"1": "January",
		"2": "February",
		"3": "March",
		"4": "April",
		"5": "May",
		"6": "June",
		"7": "July",
		"8": "August",
		"9": "September",
		"10": "October",
		"11": "November",
		"12": "December"
	},
	"es": {
		"1": "Enero",
		"2": "Febrero",
		"3": "Marzo",
		"4": "Abril",
		"5": "Mayo",
		"6": "Junio",
		"7": "Julio",
		"8": "Agosto",
		"9": "Septiembre",
		"10": "Octubre",
		"11": "Noviembre",
		"12": "Diciembre"
	},
	"pt": {
		"1": "Janeiro",
		"2": "Fevereiro",
		"3": "Março",
		"4": "Abril",
		"5": "Maio",
		"6": "Junho",
		"7": "Julho",
		"8": "Agosto",
		"9": "Setembro",
		"10": "Outubro",
		"11": "Novembro",
		"12": "Dezembro"
	},
	"ru": {
		"1": "Январь",
		"2": "Февраль",
		"3": "Март",
		"4": "Апрель",
		"5": "Май",
		"6": "Июнь",
		"7": "Июль",
		"8": "Август",
		"9": "Сентябрь",
		"10": "Октябрь",
		"11": "Ноябрь",
		"12": "Декабрь"
	},
	"tr": {
		"1": "Ocak",
		"2": "Şubat",
		"3": "Mart",
		"4": "Nisan",
		"5": "Mayıs",
		"6": "Haziran",
		"7": "Temmuz",
		"8": "Ağustos",
		"9": "Eylül",
		"10": "Ekim",
		"11": "Kasım",
		"12": "Aralık"
	},
	"fr": {
		"1": "Janvier",
		"2": "Février",
		"3": "Mars",
		"4": "Avril",
		"5": "Mai",
		"6": "Juin",
		"7": "Juillet",
		"8": "Août",
		"9": "Septembre",
		"10": "Octobre",
		"11": "Novembre",
		"12": "Décembre"
	},
	"de": {
		"1": "Januar",
		"2": "Februar",
		"3": "März",
		"4": "April",
		"5": "Mai",
		"6": "Juni",
		"7": "Juli",
		"8": "August",
		"9": "September",
		"10": "Oktober",
		"11": "November",
		"12": "Dezember"
	},
	"it": {
		"1": "Gennaio",
		"2": "Febbraio",
		"3": "Marzo",
		"4": "Aprile",
		"5": "Maggio",
		"6": "Giugno",
		"7": "Luglio",
		"8": "Agosto",
		"9": "Settembre",
		"10": "Ottobre",
		"11": "Novembre",
		"12": "Dicembre"
	},
	"kz": {
		"1": "Қаңтар",
		"2": "Ақпан",
		"3": "Наурыз",
		"4": "Сәуір",
		"5": "Мамыр",
		"6": "Маусым",
		"7": "Шілде",
		"8": "Тамыз",
		"9": "Қыркүйек",
		"10": "Қазан",
		"11": "Қараша",
		"12": "Желтоқсан"
	}
};
